import PropTypes from 'prop-types';
import clsx from 'clsx';
import DynamicPropsInjection from '@/components/DynamicPropsInjection';
import { ShapeSpacing } from '@/shapes';

const defaultProps = {
  horizontal: null,
  vertical: null,
  top: null,
  bottom: null,
  left: null,
  right: null,
  type: 'm',
  inject: false,
  className: '',
  children: null,
};

const propTypes = {
  horizontal: ShapeSpacing,
  vertical: ShapeSpacing,
  top: ShapeSpacing,
  bottom: ShapeSpacing,
  left: ShapeSpacing,
  right: ShapeSpacing,
  type: PropTypes.oneOf(['m', 'p']),
  inject: PropTypes.bool,
  className: PropTypes.string,
  children: PropTypes.node,
};

export default function Spacing({
  horizontal,
  vertical,
  top,
  bottom,
  left,
  right,
  type,
  inject,
  className,
  children,
  ...rest
}) {
  let classes = [className];

  if (horizontal || (left === right && left !== null)) {
    classes = [...classes, `${type}x-${horizontal || left}`];
  } else {
    if (left !== null) {
      classes = [...classes, `${type}l-${left}`];
    }

    if (right !== null) {
      classes = [...classes, `${type}r-${right}`];
    }
  }

  if (vertical || (top === bottom && top !== null)) {
    classes = [...classes, `${type}y-${vertical || top}`];
  } else {
    if (top !== null) {
      classes = [...classes, `${type}t-${top}`];
    }

    if (bottom !== null) {
      classes = [...classes, `${type}b-${bottom}`];
    }
  }

  let content;
  if (!inject) {
    content = <div>{children}</div>;
  } else {
    content = children;
  }

  return (
    <DynamicPropsInjection className={clsx(classes)} props={rest}>
      {content}
    </DynamicPropsInjection>
  );
}

Spacing.defaultProps = defaultProps;
Spacing.propTypes = propTypes;

export { defaultProps, propTypes };
